<template>
  <div class="flex flex-row">
    <div class="bg-static-default-mid rounded-full mr-12 flex h-max p-8">
      <slot name="icon"></slot>
    </div>
    <div class="mt-8">
      <p class="body-1-bold">
        <slot name="title">{{ title }}</slot>
      </p>

      <p class="text-static-default-low body-2">
        <slot name="description">{{ description }}</slot>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface XrInformationRowProps {
  title?: string
  description?: string
}
defineProps<XrInformationRowProps>()
</script>
